import { type Location } from "../model/types"
import { BOX_WIDTH, grid_to_plane, type PlaneLocation } from "./grid"

type CameraState = {
  pan_x: number
  pan_y: number
  scale: number
}

type ViewLocation = {
  vx: number
  vy: number
}

const view_to_plane = (
  { vx, vy }: ViewLocation,
  { pan_x, pan_y, scale }: CameraState,
): PlaneLocation => ({
  px: (vx - pan_x) / scale,
  py: (vy - pan_y) / scale,
})

const plane_to_grid = ({ px, py }: PlaneLocation): Location => ({
  gx: Math.floor(px / BOX_WIDTH),
  gy: Math.floor(py / BOX_WIDTH),
})

const view_to_grid = (view_location: ViewLocation, camera_state: CameraState): Location => {
  return plane_to_grid(view_to_plane(view_location, camera_state))
}

const plane_to_view = (
  { px, py }: PlaneLocation,
  { pan_x, pan_y, scale }: CameraState,
): ViewLocation => ({
  vx: px * scale + pan_x,
  vy: py * scale + pan_y,
})

const grid_to_view = (location: Location, camera_state: CameraState): ViewLocation => {
  return plane_to_view(grid_to_plane(location), camera_state)
}

export type { CameraState, PlaneLocation, ViewLocation }

export { grid_to_plane, grid_to_view, plane_to_grid, plane_to_view, view_to_grid, view_to_plane }
